export const ElectricityManualLookupFixture = [
  {
    icp: "0000038083TR198",
    address: "6 Logie Street Lower Hutt 5019",
    icpStatus: 2,
  },
];
